export default __webpack_public_path__ + "images/fox-map-v3x2.png";